module.exports = __webpack_public_path__ + "static/media/noPhoto.6b81e59f.png";